/**
 * @generated SignedSource<<0299a6510723afa421df98e270a8e1b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RSVPToEventsInput = {
  excludeCommunityEvents?: boolean | null;
  excludeProductEvents?: boolean | null;
  includedProductIds?: ReadonlyArray<string> | null;
  organizationId: string;
};
export type RSVPToAllOrganizationEventsButtonMutation$variables = {
  input: RSVPToEventsInput;
};
export type RSVPToAllOrganizationEventsButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly occurrences: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly atCapacity: boolean;
          readonly hasViewerRSVPd: boolean;
          readonly id: string;
          readonly rsvps: {
            readonly totalCount: number;
          } | null;
        };
      }>;
    } | null;
  };
};
export type RSVPToAllOrganizationEventsButtonMutation = {
  response: RSVPToAllOrganizationEventsButtonMutation$data;
  variables: RSVPToAllOrganizationEventsButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RSVPToEventsResponse",
    "kind": "LinkedField",
    "name": "rsvpToEvents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OccurrenceNodeConnection",
        "kind": "LinkedField",
        "name": "occurrences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OccurrenceNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Occurrence",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasViewerRSVPd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "atCapacity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceRSVPNodeConnection",
                    "kind": "LinkedField",
                    "name": "rsvps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RSVPToAllOrganizationEventsButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RSVPToAllOrganizationEventsButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9949b7bc4352bf7cb60018f7c9f28300",
    "id": null,
    "metadata": {},
    "name": "RSVPToAllOrganizationEventsButtonMutation",
    "operationKind": "mutation",
    "text": "mutation RSVPToAllOrganizationEventsButtonMutation(\n  $input: RSVPToEventsInput!\n) {\n  response: rsvpToEvents(input: $input) {\n    occurrences {\n      edges {\n        node {\n          id\n          hasViewerRSVPd\n          atCapacity\n          rsvps {\n            totalCount\n          }\n        }\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b00373d475bcbf238b639cd8f4a15f26";

export default node;
